import type { GlobalPosition, GoalPosition } from "@repo/shared/types";

export type FlowTemplateCategory =
  | "execution"
  | "advisory-single"
  | "advisory-multi"
  | "self-service"
  | "specialized";

export type FlowTemplateComponent = {
  type: string;
  config?: Record<string, unknown>;
  columnPosition?: "left" | "right" | null;
  tabId?: string | null;
};

export type FlowTemplateLayout = {
  layoutType: "two_column" | "tabs_block";
  config?: Record<string, unknown>;
  components: FlowTemplateComponent[];
};

export type FlowTemplatePage = {
  name: string;
  visibility: "internal" | "public";
  pageType: "global" | "goal" | "portfolio";
  globalPosition?: GlobalPosition;
  /** QL-117 — goal pages only; defaults to before the portfolios. */
  goalPosition?: GoalPosition;
  enableAdvisorNotes?: boolean;
  // Components without layouts (legacy support)
  components?: FlowTemplateComponent[];
  // Layouts with nested components (new structure)
  layouts?: FlowTemplateLayout[];
};

export type FlowTemplate = {
  key: string;
  category: FlowTemplateCategory;
  language: string; // e.g., "en_GB", "nb_NO"
  name: string;
  description: string;
  badges: string[];

  // Flow settings
  multiGoal: boolean;
  multiPortfolio?: boolean;
  allowPublicStart: boolean;
  allowPublicPdfGen: boolean;
  allowPublicSigning: boolean;

  // Pages definition
  pages: FlowTemplatePage[];
};

export const TEMPLATE_CATEGORIES: Record<FlowTemplateCategory, { order: number }> = {
  execution: {
    order: 1,
  },
  "advisory-single": {
    order: 2,
  },
  "advisory-multi": {
    order: 3,
  },
  "self-service": {
    order: 4,
  },
  specialized: {
    order: 5,
  },
};
